
export const ASSESSMENT_CONSTANTS = {
  MINIMUM_WORDS_REQUIRED: 8,
  Z_SCORE_RANGE: {
    MIN: -3,
    MAX: 3
  },
  SCORING: {
    SCALE_FACTOR: 4,
    BALANCE_ADJUSTMENT: {
      PRIMARY: 1.5,
      SECONDARY: 1.0
    }
  }
} as const;
